import React from 'react'
import { Trans, t } from '@lingui/macro'
import { useDisclosure } from '@chakra-ui/react'
import IconFilter from 'public/assets/img/filter-icon.svg'
import { ButtonDark } from 'front-end/src/components'
import './SurveyResultsFilter.less'
import { DateRangeFilterModal } from '../../../../components/common/date-range-filter-modal/DateRangeFilterModal'
import IconPencil from 'front-end/src/components/common/icon/IconPencil'
import { useDateFilterContext } from '../../../../components/common/dateFilter'
import { showSelectedRangeOrCustom } from '../../../../components/utils/predefinedDateRanges'

const SurveyResultsFilter = () => {
  const [filters, setFilters] = useDateFilterContext()
  const disclosure = useDisclosure()

  return (
    <div className="SurveyResultsFilter">
      <div className="SurveyResultsFilter__wrapper">
        <label className="SurveyResultsFilter__label">
          <img
            className="SurveyResultsFilter__label__icon"
            src={IconFilter}
            alt={t`Filter`}
          />
          <Trans>Showing</Trans>:
        </label>
        <ButtonDark
          className="SurveyResultsFilter__item"
          onClick={disclosure.onOpen}
          leftIcon={<IconPencil />}
        >
          <span className="AnalyticsFilter__item__label">
            <Trans>Date</Trans>: {showSelectedRangeOrCustom(filters)}
          </span>
        </ButtonDark>
      </div>
      <DateRangeFilterModal
        isOpened={disclosure.isOpen}
        closeModal={disclosure.onClose}
        onFilterSubmit={setFilters}
        {...filters}
      />
    </div>
  )
}

export default SurveyResultsFilter
